import request from '@/sheep/request';

// 愿望消息
export interface MemberMessage {
	userId?: number
	templateNickname?: string
	templateContent?: string
	readStatus?: number
	readTime?: number
}


// 获取消息列表 分页
export const getMemberMessagePage = async (params?: any) => {
	return request({
		url: '/member/notify-message/page',
		method: 'GET',
		params,
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}

// 获取当前用户的最新站内信列表（未读优先）
export const getUnreadNotifyMessageList = async (params?: any) => {
	return request({
		url: '/member/notify-message/get-unread-list',
		method: 'GET',
		params,
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}


// 获得当前用户的未读站内信数量
export const getMessageUnreadCount = async () => {
	return request({
		url: '/member/notify-message/get-unread-count',
		method: 'GET',
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}

// 标记所有站内信为已读
export const updateAllNotifyMessageRead = async () => {
	return request({
		url: '/member/notify-message/update-all-read',
		method: 'PUT',
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}

// 标记单条站内信为已读
export const updateNotifyMessageRead = async (id: number) => {
	return request({
		url: '/member/notify-message/update-read',
		method: 'PUT',
		params: { id },
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}

export const deleteMemberMessage = async (id: number) => {
	return request({
		url: '/member/notify-message/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}

export const deleteSystemMessage = async (id: number) => {
	return request({
		url: '/member/notify-message/system/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}

export const clearInteractMessage = async () => {
	return request({
		url: '/member/notify-message/interact/clear',
		method: 'GET',
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}

export const clearSystemMessage = async () => {
	return request({
		url: '/member/notify-message/system/clear',
		method: 'GET',
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}